define([
    'jQuery',
    'underscore',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object'
], function ($, _, Widget, Object) {

    /**
     * The HotelSearchWidget constructor
     *
     * @constructor
     * @name HotelSearchWidget
     * @extends Widget
     * @param {String} element A CSS selector to the root element of the widget
     * @param {Object} [options] An optional options object
     */
    var HotelSearchWidget = function (element, options) {
        Widget.apply(this, arguments);
        if (this.element.length === 0) {
            return;
        }
        var defaultOptions = {
            triggerRedirect: false,
            rootScope: null
        };

        // Add default options and custom options
        this.addOptions(defaultOptions, options);

        // Startup
        this._init();
    };

    HotelSearchWidget.prototype = /** @lends HotelSearchWidget */ $.extend(Object.create(Widget.prototype), {

        /**
         * A reference to the input field
         *
         * @type {jQuery}
         */
        searchField: null,

        /**
         * A reference to the submit button
         *
         * @type {jQuery}
         */
        submitButton: null,

        /**
         * The current query string
         *
         * @type {String}
         */
        currentQuery: '',

        /**
         * The place holder string
         *
         * @type {String}
         */
        placeholder: '',

        /**
         * The base route to redirect to
         *
         * @type {String}
         */
        redirectTarget: '',

        /**
         * Runs widget startup
         *
         * @returns {void}
         * @private
         */
        _init: function () {
            this._obtainNodeReferences();
            this._runConnections();

            this.placeholder = this.element.data('placeholder');
            this.redirectTarget = this.element.data('redirect-target');

            this.setValueToUi();
        },

        /**
         * Gathers node references
         *
         * @returns {void}
         * @private
         */
        _obtainNodeReferences: function () {
            this.submitButton = $('[data-fcse-role="hotelsearch-submit"]', this.element);
            this.searchField = $('[data-fcse-role="hotelsearch-input"]', this.element);
        },

        /**
         * Runs event connections
         *
         * @returns {void}
         * @private
         */
        _runConnections: function () {
            this.submitButton.on('click', $.proxy(this._onSubmitButtonClick, this));
            this.searchField.on('focus', $.proxy(this._onSearchFieldFocus, this));
            this.searchField.on('blur', $.proxy(this._onSearchFieldBlur, this));
            this.searchField.on('keydown', $.proxy(this._onSearchFieldKeyDown, this));
        },

        /**
         * Called when the user clicks on the submit button. Set's the value to
         * scope if it is a non-empty user entered value.
         *
         * @param {jQuery.Event} evt The jQuery click event
         * @returns {void}
         * @private
         */
        _onSubmitButtonClick: function (evt) {
            evt.stopImmediatePropagation();
            evt.preventDefault();

            this._updateHotelNameQuery();
        },

        /**
         * Called when user focuses the search field. Handles placeholder
         * placement.
         *
         * @returns {void}
         * @private
         */
        _onSearchFieldFocus: function () {
            if (_.isObject(this.searchField)) {
                if (this._getTrimmedSearchFieldValue() == this.placeholder) {
                    this.searchField.val('');
                }
            }
        },

        /**
         * Called when user leaves the search field. Handles placeholder
         * placement and triggers a value update.
         *
         * @returns {void}
         * @private
         */
        _onSearchFieldBlur: function () {
            if (_.isObject(this.searchField)) {
                if (!this._getTrimmedSearchFieldValue().length) {
                    this.searchField.val(this.placeholder);
                }
            }

            this._updateHotelNameQuery();
        },

        /**
         * Monitors key presses on the search field. Will call the submit
         * handler if the return key is pressed.
         *
         * @param {jQuery.Event} evt The keydown event
         * @returns {void}
         * @private
         */
        _onSearchFieldKeyDown: function (evt) {
            if (evt.which == 13) {
                this.searchField.blur();
                this._onSubmitButtonClick(evt);
            }
        },

        /**
         * Updates the scope object with the value present in the search field.
         *
         * @returns {void}
         * @private
         */
        _updateHotelNameQuery: function () {
            var hotelNameQuery = this._getTrimmedSearchFieldValue();

            if (hotelNameQuery == this.placeholder) {
                hotelNameQuery = '';
            }

            if (!hotelNameQuery.length) {
                // TODO: We may want to handle empty queries here differently.
                // However, as I see it, it's the only way to reset a hotel
                // name search.
            }
            this.currentQuery = hotelNameQuery;
            
            if (this._options.triggerRedirect && !!this.currentQuery.length) {
                var rootScopeQuery = $.extend(this._options.rootScope.getQuery(), {
                        'hotelName': hotelNameQuery
                    }),
                    url = this.redirectTarget + '?' + $.param(rootScopeQuery);

                window.location.href = url;
            } else {
                this.setValue(hotelNameQuery);
            }
        },

        /**
         * Returns the trimmed search field value
         *
         * @returns {String} The trimmed search field value
         * @private
         */
        _getTrimmedSearchFieldValue: function () {
            if (!_.isObject(this.searchField)) {
                return '';
            }
            return $.trim(this.searchField.val());
        },

        /**
         * Sets the scope value to the search field
         *
         * @returns {void}
         */
        setValueToUi: function () {
            this.currentQuery = this.getValue();
            if (_.isObject(this.searchField)) {
                this.searchField.val(this.currentQuery.length ? this.currentQuery : this.placeholder);
            }
        },

        /**
         * Returns the current hotel name search query
         *
         * @returns {String} The hotel name search query
         */
        getValueFromUi: function () {
            return this.currentQuery;
        }
    });

    return HotelSearchWidget;
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/hotelsearch/hotelSearchWidget.js